import { render, staticRenderFns } from "./KMenu.vue?vue&type=template&id=7beedea1&"
import script from "./KMenu.vue?vue&type=script&lang=ts&"
export * from "./KMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports